export default {
  props: {
    executor: {
      required: true,
    },
    status: {
      required: true,
    },
    jobType: {
      required: true,
    },
  },
};
